import React from "react";
import * as Styles from "./styles";
import * as Icon from "../../../../../../assets/iconsSVG";

interface Props {
  onZoonIn: () => void;
  onZoonOut: () => void;
}

const Footer: React.FC<Props> = (props) => {
  return (
    <Styles.Container>
      <Styles.Button onClick={() => props?.onZoonIn()}>
        <Icon.ZoomInIcon />
      </Styles.Button>
      <Styles.Button onClick={() => props?.onZoonOut()}>
        <Icon.ZoomOutIcon />
      </Styles.Button>
    </Styles.Container>
  );
};

export default Footer;
